
export default function bindAutoLoad(element){
  if($(element).hasClass("u2diViewPortBind")===false){
    $(element).bind('scroll', function(){
      $(element).addClass("u2diViewPortBind");

      $('[class$="loadMore"] button').each(function () {
        if(isInViewport(this)){
          $(this).click();
        }
      });
    });
  }
}

function isInViewport(elem){
  const docViewTop = $(window).scrollTop();
  const docViewBottom = docViewTop + $(window).height();

  const elemTop = $(elem).offset().top;
  const elemBottom = elemTop + $(elem).height();

  return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}